import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pad10 with_white_bg noscroll",
  style: {"height":"450px"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: /*#__PURE__*/_normalizeClass(`title mt20 mb10`)
}, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "fs24 kakugo centered fw600",
    style: {"color":"#696969"}
  }, "公開ページリンク")
], -1)
const _hoisted_4 = {
  class: "w100",
  style: {
                    height: `50px`,
                    textAlign: `center`,
                    borderBottom: `1px solid #ddd`,
                }
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "warningText fs12 kakugo centered" }, [
  /*#__PURE__*/_createTextVNode("公開ページのURLになります。"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_6 = { style: {"margin-top":"30px"} }
const _hoisted_7 = { class: "mt30" }
const _hoisted_8 = { class: "fl fw600 ml10" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "fl mr5" }, "公開ボードとして利用", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "fs12 mt30" }, "こちらをコピーしてホームページなどに貼り付けてください。", -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "fs12 mt30" }, [
  /*#__PURE__*/_createTextVNode(" オペレータが対応可能な場合のみボタンが表示されます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" スグINボタンのみ表示する場合、フォームの入力がiframeの制限によりできません。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 代わりに、ボタンを押した際にリダイレクト先のURLを指定することができます。 ")
], -1)
const _hoisted_16 = { class: "fs12 w100 fw600" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UrlWithQRcodeContent = _resolveComponent("UrlWithQRcodeContent")!
  const _component_IconHelp = _resolveComponent("IconHelp")!
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!
  const _component_CopyButton = _resolveComponent("CopyButton")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "PublicLinkModal",
    "content-class": "ofs modalContent shadowContent rad10 modalNarrow noscroll"
  }, {
    default: _withCtx(() => [
      (_ctx.room)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _hoisted_3,
            _createElementVNode("section", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass(`roomsCategoryTab categoryFixed pointer centered fl w50 ${
                        _ctx.selectedTabName == 'link' ? 'selected fw600' : ''
                    }`),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectCategoryTab('link')))
              }, " リンク ", 2),
              _createElementVNode("div", {
                class: _normalizeClass(`roomsCategoryTab categoryAll pointer centered fl w50 ${
                        _ctx.selectedTabName == 'embeds' ? 'selected fw600' : ''
                    }`),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectCategoryTab('embeds')))
              }, " 埋め込み ", 2)
            ]),
            (_ctx.selectedTabName == `link`)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "text centered",
                  style: _normalizeStyle({
                    padding: `20px`,
                    color: `#696969`,
                    width: _ctx.isSP ? `100%` : `410px`,
                })
                }, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_UrlWithQRcodeContent, {
                      url: _ctx.room.page_url
                    }, null, 8, ["url"])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("h5", _hoisted_8, [
                      _hoisted_9,
                      _createVNode(_component_IconHelp, {
                        width: 18,
                        class: "fl mr10",
                        tooltipText: `公開ボードとして利用すると、日程候補が非表示になります。`,
                        style: {"margin-top":"-3px"}
                      }),
                      _hoisted_10
                    ]),
                    _createVNode(_component_UrlWithQRcodeContent, {
                      url: _ctx.boardUrl,
                      index: 1000,
                      hideQRcode: true
                    }, null, 8, ["url"]),
                    _hoisted_11
                  ])
                ], 4))
              : (_ctx.selectedTabName == `embeds`)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _hoisted_13,
                    (_ctx.isInstantRoom)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _hoisted_15,
                          _createElementVNode("div", null, [
                            _createVNode(_component_TextfieldTag, {
                              value: _ctx.instantRoomRedirectUrl || `https://link.waaq.jp`,
                              onInputValue: _ctx.inputRedirectUrl
                            }, null, 8, ["value", "onInputValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("label", _hoisted_16, [
                      _createVNode(_component_CopyButton, {
                        linkUrl: _ctx.getEmbedsHtml,
                        gtagCategory: `iframeをコピー`,
                        buttonName: `タグをコピー`,
                        class: "fr"
                      }, null, 8, ["linkUrl"])
                    ]),
                    _hoisted_17,
                    _createVNode(_component_TextareaTag, {
                      placeholder: "こちらをコピーしてホームページなどに貼り付けてください。",
                      style: {"height":"200px"},
                      class: "fs14 roundForm mw100 mt10 pageIframe",
                      value: _ctx.getEmbedsHtml,
                      onClickTextarea: _ctx.clickTextarea
                    }, null, 8, ["value", "onClickTextarea"]),
                    _hoisted_18
                  ]))
                : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}